import { defineMessages } from "react-intl"

export const EXTERNAL_FORM_MESSAGES = defineMessages({
    select_form_label: {
        id: "integration.form.edit.name_label",
        defaultMessage: "Select form", 
    },
    create_form_label: {
        id: "integration.form.edit.wix.create_draft_quote_on_form_submission",
        defaultMessage: "Create a draft quote upon form submission",
    },
})


// WEBPACK FOOTER //
// ./src/utils/external-forms/message.ts